import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Smartphone } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-cream pt-8 pb-12 lg:pt-14 lg:pb-16" data-id="element-276">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <div className="lg:grid lg:grid-cols-12 lg:gap-12 items-center" data-id="element-278">
          {/* Text Content */}
          <div className="lg:col-span-6 text-center lg:text-left mb-16 lg:mb-0 z-10" data-id="element-279">
            <h1 className="font-serif font-bold text-sage tracking-tight mb-6 leading-tight" data-id="element-280">
              <span className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl whitespace-nowrap" data-id="element-281">
                Protocolo Vientre Plano 40+
              </span>
              <br data-id="element-282" />
              <span className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl italic font-normal" data-id="element-283">
                El Sistema de 28 Días para Resetear el Metabolismo y Eliminar la
                Hinchazón Hormonal.
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-sage/80 font-sans mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-284">
              ¿Vientre hinchado? No es tu culpa, es tu biología. 'Apaga' la
              inflamación inhibiendo la enzima COX-2 sin dejar de comer lo que
              amas.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4 mb-8" data-id="element-285">
              <a href="#resumen-inversion" className="w-full sm:w-auto" onClick={e => {
              e.preventDefault();
              document.getElementById('resumen-inversion')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-286">
                <Button size="xl" variant="primary" className="w-full sm:w-auto shadow-gold/30" data-id="element-287">
                  SÍ, QUIERO MI RESET METABÓLICO
                </Button>
              </a>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 text-sm font-medium text-sage/70" data-id="element-288">
              <div className="flex items-center" data-id="element-289">
                <Zap className="w-4 h-4 text-gold mr-2" data-id="element-290" />
                Acceso inmediato
              </div>
              <div className="flex items-center" data-id="element-291">
                <ShieldCheck className="w-4 h-4 text-gold mr-2" data-id="element-292" />
                Garantía 30 días
              </div>
              <div className="flex items-center" data-id="element-293">
                <Smartphone className="w-4 h-4 text-gold mr-2" data-id="element-294" />
                100% digital
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="lg:col-span-6 relative" data-id="element-295">
            <div className="relative w-full max-w-lg mx-auto lg:max-w-none" data-id="element-296">
              {/* Background decorative element */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gold/5 rounded-full blur-3xl -z-10" data-id="element-297"></div>

              {/* Top Row: Two side-by-side images */}
              <div className="flex gap-4 mb-4" data-id="element-298">
                {/* Left - Mujer Hinchada */}
                <div className="w-1/2 rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform -rotate-2" data-id="element-299">
                  <img src="https://cdn.magicpatterns.com/uploads/rHEwAdS5HPkwBT1z3z7g5B/mujerhinchada.png" alt="Mujer con vientre hinchado" className="w-full h-full object-cover aspect-[3/4]" data-id="element-300" />
                </div>

                {/* Right - Mujer Sonriente */}
                <div className="w-1/2 rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2" data-id="element-301">
                  <img src="https://cdn.magicpatterns.com/uploads/98trXg9cf3YQCrBoQCnage/mujersonriente.png" alt="Mujer sonriente y saludable" className="w-full h-full object-cover aspect-[3/4]" data-id="element-302" />
                </div>
              </div>

              {/* Bottom: Ebook */}
              <div className="w-3/4 mx-auto rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-white" data-id="element-303">
                <img src="https://cdn.magicpatterns.com/uploads/bNonPf28N1GYLUPsiT7ZGV/ebook.png" alt="Ebook Protocolo Vientre Plano" className="w-full h-auto object-contain" data-id="element-304" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}